import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.jsx";
import Book from "./pages/Book.jsx";
import Flights from "./pages/Flights.jsx";
import SlotDetail from "./pages/SlotDetail.jsx";
import Garage from "./pages/Garage.jsx";
import AircraftEdit from "./pages/AircraftEdit.jsx";
import Profile from "./pages/Profile.jsx";
import Documents from "./pages/Documents.jsx";
import Settings from "./pages/Settings.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import AdminPilots from "./pages/AdminPilots.jsx";
import AdminPilot from "./pages/AdminPilot.jsx";
import AdminDayStatus from "./pages/AdminDayStatus.jsx";
import AdminAnnounce from "./pages/AdminAnnounce.jsx";
import Login from "./pages/Login.jsx";
import Welcome from "./pages/Welcome.jsx";
import NotFound from "./pages/NotFound.jsx";
import AuthGate from "./components/AuthGate.jsx";
import SuperadminLayout from "./pages/superadmin/Layout.jsx";
import SuperadminDashboard from "./pages/superadmin/Dashboard.jsx";
import SuperUsersList from "./pages/superadmin/UsersList.jsx";
import SuperUserDetail from "./pages/superadmin/UserDetail.jsx";
import SuperAirfieldsList from "./pages/superadmin/AirfieldsList.jsx";
import SuperAirfieldDetail from "./pages/superadmin/AirfieldDetail.jsx";
import SuperAuditLog from "./pages/superadmin/AuditLog.jsx";
import SuperWarnings from "./pages/superadmin/WarningsList.jsx";
import SuperDocuments from "./pages/superadmin/DocumentsQueue.jsx";
import SuperMessages from "./pages/superadmin/MessagesList.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          <AuthGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<Book />} />
              <Route path="/flights" element={<Flights />} />
              <Route path="/slot/:slug/:date/:hhmm" element={<SlotDetail />} />
              <Route path="/garage" element={<Garage />} />
              <Route path="/garage/new" element={<AircraftEdit />} />
              <Route path="/garage/:id" element={<AircraftEdit />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/documents" element={<Documents />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin/:slug" element={<AdminDashboard />} />
              <Route path="/admin/:slug/pilots" element={<AdminPilots />} />
              <Route path="/admin/:slug/pilot/:userId" element={<AdminPilot />} />
              <Route path="/admin/:slug/day" element={<AdminDayStatus />} />
              <Route path="/admin/:slug/announce" element={<AdminAnnounce />} />
              <Route path="/superadmin" element={<SuperadminLayout />}>
                <Route index element={<SuperadminDashboard />} />
                <Route path="users" element={<SuperUsersList />} />
                <Route path="users/:id" element={<SuperUserDetail />} />
                <Route path="airfields" element={<SuperAirfieldsList />} />
                <Route path="airfields/:slug" element={<SuperAirfieldDetail />} />
                <Route path="audit" element={<SuperAuditLog />} />
                <Route path="warnings" element={<SuperWarnings />} />
                <Route path="documents" element={<SuperDocuments />} />
                <Route path="messages" element={<SuperMessages />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthGate>
        }
      />
    </Routes>
  );
}
